import Component from './btn-group.vue';
export default Component;
